export default __webpack_public_path__ + "static/O0173-38a9af53ca08eb8eea344b1783785fa2.png";